/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Pit1_DInputs */

const en_to_csv_pit1_d = /** @type {(inputs: To_Csv_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A key holding null and a key that is missing entirely both produce an empty cell. If that distinction matters in your data, CSV cannot carry it and you need to encode it yourself, for example by substituting a sentinel string before converting. This is a limitation of the format, not of the tool.`)
};

const ko_to_csv_pit1_d = /** @type {(inputs: To_Csv_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`null을 담은 키와 아예 없는 키가 모두 빈 칸을 만듭니다. 그 구분이 데이터에서 중요하다면 CSV는 그것을 담을 수 없으므로 직접 인코딩해야 합니다. 예를 들어 변환 전에 표식 문자열로 치환하는 방법이 있습니다. 도구의 한계가 아니라 형식의 한계입니다.`)
};

const ja_to_csv_pit1_d = /** @type {(inputs: To_Csv_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`null を持つキーとまったく存在しないキーの両方が空のセルになります。その区別がデータで重要なら、CSV はそれを運べないので自分で符号化する必要があります。たとえば変換前に目印の文字列に置き換える方法があります。ツールの制限ではなく形式の制限です。`)
};

/**
* | output |
* | --- |
* | "A key holding null and a key that is missing entirely both produce an empty cell. If that distinction matters in your data, CSV cannot carry it and you need ..." |
*
* @param {To_Csv_Pit1_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_pit1_d = /** @type {((inputs?: To_Csv_Pit1_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Pit1_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_pit1_d(inputs)
	if (locale === "ko") return ko_to_csv_pit1_d(inputs)
	return ja_to_csv_pit1_d(inputs)
});